import 'regenerator-runtime/runtime';
import { all } from 'redux-saga/effects';
import { watchStateSnapshot } from './stateSnapshotSaga';
import { watchStreckeSnapshot } from './streckeSnapshotSaga';
import { streckenTarifierungRS } from './streckenTarifierungRS';
import { watchVersicherterBereichChanged } from './versicherterBereichChangedSaga';
import { watchInDashboardUebernehmenSaga } from './inDashboardUebernehmenSaga';
import { shopTarifierungRS } from './shopTarifierungRS';
import { watchAntragsnummerRequested } from './antragsnummerSaga';
import { watchproduktlinienSaga } from './liniensteuerungSaga';
import { watchRechtsstreitigkeitenChangedSaga } from './resetSelbstbehaltSaga';
import { watchVorschlagdatenChanged } from './vorschlagdatenSaga';
import { watchDruckdatenRequested } from './druckdatenSaga';
import { watchQuoteDB } from './quoteDbSaga';
import { watchVorbelegungRequested } from './vorbelegungSaga';
import { updateRisikoortAfterLoadAzamSaga } from './updateRisikoortAfterLoadAzamSaga';
import { handleRsNavigationToAngebotSaga } from './handleRsNavigationToAngebotSaga';

export function* rootSaga() {
  yield all([
    watchStateSnapshot(),
    watchStreckeSnapshot(),
    streckenTarifierungRS(),
    watchVersicherterBereichChanged(),
    watchInDashboardUebernehmenSaga(),
    shopTarifierungRS(),
    watchAntragsnummerRequested(),
    watchVorschlagdatenChanged(),
    watchproduktlinienSaga(),
    watchRechtsstreitigkeitenChangedSaga(),
    watchQuoteDB(),
    watchDruckdatenRequested(),
    watchVorbelegungRequested(),
    updateRisikoortAfterLoadAzamSaga(),
    handleRsNavigationToAngebotSaga(),
  ]);
}
